<template>
  <el-submenu index="6" style="float: right" v-loading="loading">
    <template slot="title">
      <i class="el-icon-user"></i>
      <span slot="title"> {{ username }} </span>
    </template>
    <el-menu-item index="profile" @click="profile()">Perfil</el-menu-item>
    <el-menu-item index="logout" @click="logout()">Sair</el-menu-item>
  </el-submenu>
</template>

<script>
import { UserService } from "@/services/users/user.services";
export default {
  name: "AppHeaderMenuUserInfo",
  data() {
    return {
      loading: false,
      username: "",
    };
  },
  methods: {
    profile() {
      this.$router.replace({ name: "profile" });
    },
    logout() {
      this.$emit('logout');
    },
  },
  mounted() {
    const vm = this;
    vm.loading = true;
    UserService.me()
      .then((response) => {
        console.log('me', response)
        vm.username = response.name;
      })
      .finally(() => vm.loading = false)
  }
}
</script>